import { FC, HTMLAttributes, useState } from 'react';
import classNames from 'classnames';
import { MyButton, MyButtonProps } from './MyButton';
import { useTranslation } from 'react-i18next';


export interface Item extends Pick<MyButtonProps, 'text' | 'onClick'> {
  id: string
}

export interface Props extends Pick<MyButtonProps, 'align'>, Pick<HTMLAttributes<any>, 'className'> {
  mode: 'toggle' | 'select'
  selectedId?: string|null
  items: Item[]
  helpText: string
  chooseAll?: boolean
  onClear?(): void
}

export const Selector: FC<Props> = ({ items, align, selectedId, className, mode, helpText, chooseAll, onClear }) => {
  const { t } = useTranslation()
  const [showAll, setShowAll] = useState<boolean>(false)
  const selectedItem = items.find(item => item.id === selectedId)

  const onClick = (item: Item | null) => {
    if (item === null) {
      onClear?.()
      setShowAll(false)
      return
    }

    if (mode === 'toggle') {
      item.onClick()
      setShowAll(false)

      return
    }

    if (mode === 'select') {
      setShowAll(false)
      item.onClick()

      return
    }
  }

  if (!showAll) {
    return (
      <div className={classNames(
        className,
      )}>
        <div>
          {helpText}
        </div>
        <MyButton
          align={align}
          isHl={true}
          text={selectedItem?.text ?? t('All')}
          onClick={() => setShowAll(true)}/>
      </div>
    )
  }

  return (
    <div className={classNames(
      'grid grid-cols-2 gap-2',
      className,
    )}>
      {chooseAll && (
        <MyButton
          align={align}
          isHl={selectedId === null || selectedId === undefined}
          text={t('All')}
          onClick={() => onClick(null)}/>
      )}
      {items.map(item => (
        <MyButton
          key={item.id}
          align={align}
          isHl={selectedId === item.id}
          text={item.text}
          onClick={() => onClick(item)}/>
      ))}
    </div>
  )
}
